import { render, staticRenderFns } from "./NewUserEmailInput.vue?vue&type=template&id=52b374a6"
import script from "./NewUserEmailInput.vue?vue&type=script&lang=ts"
export * from "./NewUserEmailInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports